import { render } from "./Timesheet.vue?vue&type=template&id=4490a406&scoped=true"
import script from "./Timesheet.vue?vue&type=script&lang=js"
export * from "./Timesheet.vue?vue&type=script&lang=js"

import "./timesheet.scss?vue&type=style&index=0&id=4490a406&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4490a406"]])

export default __exports__